import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useUDTopics( name ) {
   return useFetchData({
      APIMethod: API.getUDTopics,
      condition: !!name,
      cache_name: name + "-ud-topics",
      params: [ name ]
   })
}